module.exports = __webpack_public_path__ + "img/old-code.260294c2.png";